export default __webpack_public_path__ + "static/media/Kids&Us.340f82f4.webp";